<template>
  <div>
    <div v-if="title">
      <p class="text-sm font-bold pb-2 text-brand-black ml-1">{{ title }}</p>
      <p class="text-xs font-semibold pb-2 text-gray-600 ml-1">Last updated {{ updatedAt | shortTimeAgoExtended }}</p>
    </div>
    <ul v-if="customerData" role="list" class="divide-y divide-gray-200 px-1">
      <li v-for="(value, key) in sortedCustomerData" :key="key" class="relative flex items-center space-x-2 py-1.5">
        <div class="min-w-0 flex-auto flex items-center space-x-4 justify-between">
          <div>
            <div class="flex items-center gap-x-2">
              <h2 class="min-w-0 text-xs font-semibold leading-5 text-gray-800 ml-1">
                <span class="truncate">{{ formatKey(key) }}</span>
                <span class="absolute inset-0" />
              </h2>
            </div>
            <div class="mt-1.5 flex items-center gap-x-2 text-xs leading-5 text-gray-600">
              <span :class="['inline-flex items-center rounded-md px-2 py-1 text-xs font-semibold', badgeColor(value, dataTypes[key])]">{{
                formatValue(value, key)
              }}</span>
            </div>
          </div>
          <div class="flex items-center">
            <p class="whitespace-nowrap text-xs">{{ shortTimeAgoExtended(customerDataUpdatedAt[key]) }} ago</p>
          </div>
        </div>
        <i class="fas fa-chevron-right text-gray-400" aria-hidden="true"></i>
      </li>
    </ul>
  </div>
</template>

<script>
import { shortTimeAgoExtended, dateMonthYearFormat } from '@/helpers/date-utils';
import { formatIntlCurrency } from '@/helpers/currency-utils';
import { formatCondensedMoney, formatPercent } from '@/helpers/jsUtils';
import { adminColumnsToExport } from '@/store/modules/export-helpers';

export default {
  name: 'CustomerRecords',
  data() {
    return {
      shortTimeAgoExtended,
    };
  },
  props: {
    customerRecords: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    customerData() {
      return this.customerRecords?.data;
    },
    title() {
      return this.customerData?.name;
    },
    updatedAt() {
      return this.customerRecords?.updatedAt ? new Date(this.customerRecords.updatedAt) : null;
    },
    sortedCustomerData() {
      let keys;
      if (this.$store.getters.isAdmin) {
        keys = adminColumnsToExport.filter((k) => k !== 'name');
      } else {
        keys = Object.keys(filteredData);
        // const keys = Object.keys(filteredData).sort((a, b) => {
        //   const typeA = this.dataTypes[a];
        //   const typeB = this.dataTypes[b];
        //   const order = ['string', 'boolean', 'number', 'date'];
        //   return order.indexOf(typeA) - order.indexOf(typeB);
        // });
      }
      const filteredData = Object.fromEntries(Object.entries(this.customerData || {}).filter(([key, value]) => value !== 0 && key !== 'name'));
      const sortedData = {};
      keys.forEach((key) => {
        sortedData[key] = filteredData[key];
      });
      return sortedData;
    },
    customerDataUpdatedAt() {
      return this.customerRecords?.dataUpdated;
    },
    dataTypes() {
      const types = {};
      for (const key in this.customerData) {
        if (this.customerData.hasOwnProperty(key)) {
          const value = this.customerData[key];
          if (typeof value === 'string' && Date.parse(value)) {
            types[key] = 'date';
          } else {
            types[key] = typeof value;
          }
        }
      }
      return types;
    },
  },
  methods: {
    formatKey(key) {
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/[_-]/g, ' ')
        .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
    },
    formatValue(value, key) {
      switch (this.dataTypes[key]) {
        case 'string':
          return value;
        case 'number':
          if (key.includes('%')) {
            return formatPercent(value);
          }
          if (key.includes('$')) {
            formatCondensedMoney(value);
          }
          return Number.isInteger(value) ? value.toLocaleString() : formatIntlCurrency(value);
        case 'date':
          return dateMonthYearFormat(new Date(value));
        case 'boolean':
          return value ? 'True' : 'False';
        default:
          return value;
      }
    },
    badgeColor(value, type) {
      switch (type) {
        case 'string':
          return 'bg-brand-light-blue text-brand-blue';
        case 'date':
          return 'bg-purple-100 text-purple-700';
        case 'number':
          return 'bg-indigo-100 text-indigo-700';
        case 'boolean':
          return value ? 'bg-teal-100 text-teal-700' : 'bg-red-100 text-red-700';
        default:
          return 'bg-gray-100 text-gray-600';
      }
    },
  },
};
</script>
